import { render, staticRenderFns } from "./cashGiftTable.vue?vue&type=template&id=6c3173f4&scoped=true"
import script from "./cashGiftTable.vue?vue&type=script&lang=js"
export * from "./cashGiftTable.vue?vue&type=script&lang=js"
import style0 from "./cashGiftTable.vue?vue&type=style&index=0&id=6c3173f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3173f4",
  null
  
)

export default component.exports